import * as actionTypes from "./actionTypes";
import { franchiseService } from "../../service";
import { errorHelper } from "../../common/helpers";
import { constants } from "../../common/constants";

export function generateBilling(values) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.FRANCHISE_BILLING });
      const response = await franchiseService.generateBilling(values);
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.FRANCHISE_BILLING_FAILURE,
          payload: { error: data.message },
        });
        return;
      }
      dispatch({
        type: actionTypes.FRANCHISE_BILLING_SUCCESS,
        payload: { pdf_link: data.pdf_link },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.FRANCHISE_BILLING_FAILURE
      );
    }
  };
}
export function resetGenerateBilling() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_FRANCHISE_BILLING,
    });
  };
}

export function getFranchiseBilling(billing_type, month, year) {
  return async (dispatch) => {
    try {
      dispatch({ type: actionTypes.RESET_ACTIVE_FRANCHISE_BILLING });
      dispatch({ type: actionTypes.ACTIVE_FRANCHISE_BILLING });

      const response = await franchiseService.getFranchiseBilling(
        billing_type,
        month,
        year
      );
      const data = response.data;

      if (data.message) {
        dispatch({
          type: actionTypes.ACTIVE_FRANCHISE_BILLING_FAILURE,
          payload: { error: data.message },
        });

        return;
      }

      dispatch({
        type: actionTypes.ACTIVE_FRANCHISE_BILLING_SUCCESS,
        payload: { franchiseBilling: data },
      });
    } catch (error) {
      errorHelper.handle(
        error,
        dispatch,
        actionTypes.ACTIVE_FRANCHISE_BILLING_FAILURE
      );
    }
  };
}
export function resetFranchiseBilling() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_FRANCHISE_BILLING,
    });
  };
}



// WEBPACK FOOTER //
// ./src/store/franchise/actions.js